import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { ColDef } from 'ag-grid-community';
import { AppState } from 'src/app/app.state';
import { ExportableColDefWithTitle } from 'src/app/shared/ag-grid-config/store/ag-grid-config/ag-grid-config.reducer';
import { MandatoryCheckTemplateViewModel } from 'src/app/shared/models/autogenerated';
import { AdapCellClassRules } from 'src/app/shared/utils/ag-grid-utils';
import { nameof } from 'src/app/shared/utils/nameof';
import { selectAllMandatoryChecksTemplates } from '../../store/global-settings.selectors';
import { MandatoryChecksTemplatesTableActionsRendererComponent } from '../mandatory-checks-templates-actions-renderer/mandatory-checks-templates-actions-renderer.component';
import { MandatoryCheckTemplateGridCellActions } from '../../models/mandatory-check-template-grid-cell-actions.model';
import { AgGridButtonRenderer } from 'src/app/shared/components/ag-grid-button-renderer/ag-grid-button-renderer.component';
import {
  AgGridButtonRendererActions,
  AgGridButtonRendererModel,
} from 'src/app/shared/models/ag-grid-button-renderer.model';

@Component({
  standalone: false,
  selector: 'app-mandatory-checks-templates-table',
  templateUrl: './mandatory-checks-templates-table.component.html',
  styleUrls: ['./mandatory-checks-templates-table.component.scss'],
})
export class MandatoryChecksTemplatesTableComponent {
  mandatoryCheckTemplates$ = this.store.select(
    selectAllMandatoryChecksTemplates
  );

  @Output() editMandatoryCheckTemplate = new EventEmitter<string>();
  @Output() deleteMandatoryCheckTemplate = new EventEmitter<string>();

  configStoreTableName: string = 'mandatoryChecksTemplates';
  configStoreRouteIdName: string = 'phaseId';

  components = {};

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      newRowsAction: 'keep',
    },
    resizable: true,
    cellClassRules: AdapCellClassRules,
  };

  columnDefs: ExportableColDefWithTitle[] = [
    {
      field: nameof<MandatoryCheckTemplateViewModel>('owner'),
      headerName: 'owner',
      maxWidth: 170,
    },
    {
      field: nameof<MandatoryCheckTemplateViewModel>('scopeOfReview'),
      headerName: 'scope of review',
      cellRenderer: AgGridButtonRenderer,
      cellRendererParams: {
        onInit: (
          actions: AgGridButtonRendererActions,
          data: MandatoryCheckTemplateViewModel
        ) => {
          actions.setProps({
            text: data.scopeOfReview,
            style: 'blank',
            action: (data: MandatoryCheckTemplateViewModel) => {
              this.editMandatoryCheckTemplate.emit(data.id);
            },
          });
        },
      } as AgGridButtonRendererModel,
    },
    {
      field: nameof<MandatoryCheckTemplateViewModel>('relevantPhases'),
      headerName: 'relevant phases',
      maxWidth: 200,
      valueGetter: (params: { data: MandatoryCheckTemplateViewModel }) => {
        return params.data.relevantPhases?.join(', ');
      },
    },
    {
      maxWidth: 60,
      sortable: false,
      filter: false,
      resizable: false,
      cellRenderer: MandatoryChecksTemplatesTableActionsRendererComponent,
      cellRendererParams: {
        onDeleteClick: (mandatoryCheckTemplateId: string) =>
          this.deleteMandatoryCheckTemplate.emit(mandatoryCheckTemplateId),
      } as MandatoryCheckTemplateGridCellActions,
      pinned: 'right',
      ignoreExport: true,
    },
  ];

  constructor(private store: Store<AppState>) {}
}
